import type { FC } from 'react';
import { Card, Flex, Progress, Typography } from 'antd';

const { Text } = Typography;

export interface ProgressStatCardProps {
  title: string;
  metric: string;
  description: string;
  progressPercent: number;
}

/** Compact KPI card: title, metric, caption, progress bar. */
export const ProgressStatCard: FC<ProgressStatCardProps> = ({
  title,
  metric,
  description,
  progressPercent,
}) => {
  return (
    <Card className="om-kpi-card" styles={{ body: { padding: 20 } }}>
      <Flex vertical gap={10}>
        <Text className="ds-card-label">{title}</Text>
        <Text className="ds-kpi-value om-kpi-card__metric">{metric}</Text>
        <Text type="secondary" className="om-kpi-card__description">
          {description}
        </Text>
        <Progress
          percent={progressPercent}
          showInfo={false}
          strokeColor="var(--evimo-blue)"
          trailColor="#e8eef8"
          size={{ height: 8 }}
        />
      </Flex>
    </Card>
  );
};
